<template>
  <header>
    <div>
      <v-app-bar color="gray accent-4" dark>
        <v-app-bar-nav-icon @click="drawer = true"></v-app-bar-nav-icon>
        <v-img :src="assetsImage" max-width="60" max-height="40"> </v-img>
        <v-toolbar-title>Guerrilla Space</v-toolbar-title>

        <div class="flex-grow-1"></div>

        <template v-slot:extension>
          <v-tabs centered>
            <v-tab
              v-for="(menuItem, index) in menuItems"
              :key="index"
              :to="menuItem.url"
            >
              {{ menuItem.name }}
            </v-tab>
          </v-tabs>
        </template>
      </v-app-bar>
      <v-navigation-drawer v-model="drawer" fixed temporary>
        <v-list nav dense>
          <v-list-item-group>
            <v-list-item
              v-for="(menuItem, index) in menuItems"
              :key="index"
              :to="menuItem.url"
            >
              <v-list-item-title>{{ menuItem.name }}</v-list-item-title>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-navigation-drawer>
    </div>
  </header>
</template>

<script>
import constants from "../common/constants";
import AssetsImage from "@/assets/logo.png";

export default {
  name: "AppHeader",

  data() {
    return {
      assetsImage: AssetsImage,
      assetsImage_NG: "../assets/img-assets.png",
      drawer: false,
      menuItems: constants.menuItems,
    };
  },
};
</script>

<style lang="scss" scoped>
.v-app-bar__nav-icon {
  @include display_pc {
    display: none !important;
  }
}
.v-tabs {
  display: none;

  @include display_pc {
    display: block !important;
  }
}
</style>